import {PlusOutlined} from "@ant-design/icons";
import {ConfigProvider, Image, Upload} from "antd";
import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import {useDispatch, useSelector} from "react-redux";
import {SET_REMOVED_ATTACHMENT_URLS, SET_WORKFORCE_CASE_ATTACHMENT_URLS} from "../../store/features/workforceSlice";

// helper method to retrieve file
const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const WorkForceCaseImageUploadComponent = ({disabled = false}) => {
    const {attachmentUrls, removedAttachmentUrls} = useSelector((state) => state.Workforce);
    const dispatch = useDispatch();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [fileList, setFileList] = useState(attachmentUrls ?? []);

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    useEffect(() => {
        setFileList(attachmentUrls);
    }, [attachmentUrls]);


    const handleChange = ({file, fileList: newFileList}) => {
        if (file?.status !== "uploading" && file?.response?.length !== 0 && file?.status !== "removed") {
            dispatch(SET_WORKFORCE_CASE_ATTACHMENT_URLS([...attachmentUrls, sanitizeFileUploadResponse(file)]));
        }
        setFileList(newFileList); // this is to maintain the filelist in the component
    }

    const sanitizeFileUploadResponse = (file) => {
        let obj = {};
        file?.response?.map((attachment) => {
            obj = {
                uid: file?.uid ,
                name: attachment?.fileName,
                status: "done", // should be always set to done if retrieved from the server
                url: attachment?.url,
                isFromServer: 1 // need to add a flag to identify the record as server generated
            }
        });
        return obj;
    }


    const handleRemove = (data) => {
        const index = fileList.indexOf(data);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);

        if (data?.isFromServer === 1) {
            handleRemoveExistingDataFromServer(data);
        }
    }

    const handleRemoveExistingDataFromServer = (data) => {
        dispatch(SET_REMOVED_ATTACHMENT_URLS([...removedAttachmentUrls, data?.url]));
        dispatch(SET_WORKFORCE_CASE_ATTACHMENT_URLS(attachmentUrls?.filter(attachment => attachment?.url !== data?.url)))
    }

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
            type="button"
        >
            <PlusOutlined/>
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    return (
        <>
            <div className="py-3">
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: "blue",
                            borderRadius: 5,
                        },
                    }}
                >
                    <Upload
                        action={`${process.env.REACT_APP_API_BASE_URL}/File/upload-file`}
                        headers={{authorization: `Bearer ${Cookies.get("jwtToken")}`}}
                        name={"files"}
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        onRemove={handleRemove}
                        disabled={disabled}
                        defaultFileList={attachmentUrls}
                    >
                        {fileList.length >= 3 ? null : uploadButton}
                    </Upload>
                    {previewImage && (
                        <Image
                            wrapperStyle={{
                                display: "none",
                            }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(""),
                            }}
                            src={previewImage}
                        />
                    )}
                </ConfigProvider>
            </div>
        </>
    );
};

export default WorkForceCaseImageUploadComponent;
